var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DemoBase',{attrs:{"size":"xs10"}},[_vm._v(" Basic "),_c('DataTable',{attrs:{"header-group-by":"","datatable-items":_vm.items}}),_c('v-divider',{staticClass:"my-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }